// Compatibilidad de lecturas históricas; nunca validar una operación financiera con n().
export const n = (v) => (isNaN(parseFloat(v)) ? 0 : parseFloat(v));

export const clamp = (x, min=0, max=Infinity) => Math.max(min, Math.min(max, x));

const PATRON_DINERO = /^-?\d+(?:\.\d{1,2})?$/;
export const centavos = (valor, { negativo = false } = {}) => {
  if (valor == null || typeof valor === 'boolean') throw new TypeError('Monto inválido');
  const s = String(valor).trim();
  if (!PATRON_DINERO.test(s) || (!negativo && s.startsWith('-'))) throw new TypeError('Monto inválido');
  const signo = s.startsWith('-') ? -1 : 1;
  const [entero, decimal = ''] = (signo < 0 ? s.slice(1) : s).split('.');
  const c = Number(entero) * 100 + Number(decimal.padEnd(2, '0'));
  if (!Number.isSafeInteger(c) || c > 99999999999999) throw new RangeError('Monto fuera de rango');
  return signo * c;
};
export const parseDinero = (valor, opciones) => {
  try { return centavos(valor, opciones) / 100; } catch { return null; }
};
export const redondearDinero = (valor) => {
  const num = Number(valor);
  if (valor == null || typeof valor === 'boolean' || !Number.isFinite(num)) throw new TypeError('Monto inválido');
  const c = Math.round((Math.abs(num) + Number.EPSILON) * 100);
  if (!Number.isSafeInteger(c)) throw new RangeError('Monto fuera de rango');
  return (num < 0 ? -c : c) / 100;
};
export const sumarDinero = (...valores) => {
  const c = valores.reduce((s, v) => s + centavos(v, { negativo: true }), 0);
  if (!Number.isSafeInteger(c)) throw new RangeError('Suma fuera de rango');
  return c / 100;
};
export const toMoney = (x) => {
  let num;
  try { num = redondearDinero(x); } catch { return '—'; }
  return `Q ${num.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

// permite vacío o número
export const isNumericOrEmpty = (v) =>
  v === '' || v === null || v === undefined || !isNaN(parseFloat(v));

export const totalEfectivoCaja = (c = {}) => n(c.efectivoManual);

/* ---------- Dinero en quetzales (presentación; los cálculos usan números) ---------- */
/** Completa dos decimales a un monto escrito: '625' → '625.00', '625.5' → '625.50', '.5' → '0.50'. Vacío o inválido: sin cambio. */
export const completarDecimales = (v) => {
  const s = String(v ?? '').trim();
  if (s === '' || s === '-' || s === '.' || s === '-.') return s;
  const valor = parseDinero(s, { negativo: true });
  return valor === null ? s : valor.toFixed(2);
};
/** Monto con separador de miles y dos decimales (sin "Q"): '1965' → '1,965.00'. */
export const conMiles = (v) => {
  const s = String(v ?? '').trim();
  const valor = parseDinero(s, { negativo: true });
  if (valor === null) return s;
  return valor.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};
